var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.display)?_c('div',{staticClass:"white-overlay"},[_c('div',{staticClass:"loader-wrapper"},[_c('b-spinner',{staticClass:"spinner-large",attrs:{"variant":"primary"}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }